import { useProductStore } from '../../shared/pinia/modules/product.js';

export const initTabCounters = async () => {
  const galleryTabs = document.querySelectorAll('.js-gallery-button-label');
  const qaTabs = document.querySelectorAll('.js-qa-button-label');

  if (!galleryTabs.length && !qaTabs.length) return;

  const productStore = useProductStore();

  try {
    const { data } = await productStore.setTabCounters();

    galleryTabs.forEach((galleryTab) => {
      galleryTab.innerHTML = galleryTab.innerHTML.replace(
        '0',
        data.community.gallery?.total || '0'
      );
    });

    qaTabs.forEach((qaTab) => {
      qaTab.innerHTML = qaTab.innerHTML.replace(
        '0',
        data.community.qa?.total || '0'
      );
    });
  } catch (error) {
    console.error(error);
  }
};
